module.exports = __webpack_public_path__ + "static/media/icon-resume.746cc3d0.svg";